<app-govbar></app-govbar>
<mat-toolbar
  color="primary"
  [class]="toolbarClass"
  [ngStyle]="{ 'margin-top.px': gap }"
  data-testid="toolbar-header-sigresidencias"
>
  <button class="d-xxl-none" mat-icon-button (click)="toggleSideNav()" data-testid="button-side-nav">
    <mat-icon>menu</mat-icon>
  </button>
  <a [routerLink]="'/home'" data-testid="link-header-home">
    <span class="header-title ml-4">{{ titulo }}</span>
  </a>
  <span class="flex-grow-1"></span>
  <bdg-menu icon="more_vert" data-testid="menu-header">
    <bdg-menu-item
      *ngFor="let item of menuItems"
      [label]="item.label"
      [icon]="item.icon"
      [routerLink]="item.to"
    ></bdg-menu-item>
    <mat-divider></mat-divider>
    <bdg-menu-item label="Sair" icon="exit_to_app" (click)="onLogout()"></bdg-menu-item>
  </bdg-menu>
</mat-toolbar>
